// @mui/icons-material
import DashboardIcon from '@mui/icons-material/Dashboard';
import Description from '@mui/icons-material/Description';
import PersonAdd from '@mui/icons-material/PersonAdd';

export const routes = [
  {
    path: '/tableau-de-bord',
    name: 'Tableau de bord',
    icon: DashboardIcon,
  },
  {
    path: '/annonces',
    name: 'Mes offres de stage',
    icon: Description,
  },
  {
    path: '/ajouter-un-tuteur',
    name: 'Ajouter un tuteur',
    icon: PersonAdd,
  },
];
